import React, { useEffect, useState } from "react";
import { getBlogs, deleteBlog } from "../../api/BlogCategoryService";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function BlogCategoryList() {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBlogs = async () => {
    try {
      setLoading(true);

      const res = await getBlogs();

      setBlogs(Array.isArray(res?.data) ? res.data : []);
    } catch (err) {
      console.error("Failed to fetch blog categories:", err);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm("Are you sure you want to delete this blog category?");

      if (!confirmDelete) return;

      const res = await deleteBlog(id);

      if (res.success) {
        fetchBlogs();
      }
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  return (
    <div className="container p-4 np-blog-categories-page" style={{ overflowX: "hidden" }}>
      {/* Header */}
      <div className="card p-3">
        <div className="d-flex justify-content-end align-items-center mb-2">
          <button
            type="button"
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/blogcategory/add")}
          >
            <FaPlus />
            Add Blog Category
          </button>
        </div>

        {/* Loading */}
        {loading && <p>Loading blog categories...</p>}

        {/* Empty */}
        {!loading && blogs.length === 0 && (
          <p className="text-secondary">No blog categories found</p>
        )}

        {/* Blog Categories */}
        <div className="row g-3">
          {blogs.map((blog) => (
            <div className="col-md-6 d-flex" key={blog._id}>
              <div
                className="border rounded p-3 w-100"
                style={{
                  borderRadius: "12px",
                  backgroundColor: "#ffffff",
                  overflow: "hidden",
                }}
              >
                <div className="d-flex align-items-start w-100">
                  {/* Left Content */}
                  <div
                    className="flex-grow-1"
                    style={{
                      minWidth: 0,
                      overflow: "hidden",
                    }}
                  >
                    {/* Title + Icons */}
                    <div className="d-flex align-items-start w-100 mb-2">
                      <h5
                        className="fw-semibold text-dark mb-0 flex-grow-1"
                        style={{
                          minWidth: 0,
                          overflowWrap: "break-word",
                          wordBreak: "break-word",
                        }}
                      >
                        {blog.name || "-"}
                      </h5>

                      {/* Right Side Icons */}
                      <div
                        className="d-flex align-items-center gap-3 flex-shrink-0 ms-3"
                        style={{
                          whiteSpace: "nowrap",
                        }}
                      >
                        {/* View */}
                        <button
                          type="button"
                          className="border-0 bg-transparent p-0"
                          style={{ cursor: "pointer" }}
                          title="View"
                          onClick={() => navigate(`/blogcategory/view/${blog.seo?.slug}`)}
                        >
                          <FaEye size={14} color="black" />
                        </button>

                        {/* Edit */}
                        <button
                          type="button"
                          className="border-0 bg-transparent p-0"
                          style={{ cursor: "pointer" }}
                          title="Edit"
                          onClick={() =>
                            navigate(`/blogcategory/edit/${blog.seo?.slug}`, {
                              state: {
                                blogId: blog._id,
                                slug: blog.seo?.slug,
                              },
                            })
                          }
                        >
                          <FaEdit size={14} color="black" />
                        </button>

                        {/* Delete */}
                        <button
                          type="button"
                          className="border-0 bg-transparent p-0"
                          style={{ cursor: "pointer" }}
                          title="Delete"
                          onClick={() => handleDelete(blog._id)}
                        >
                          <FaTrash size={14} />
                        </button>
                      </div>
                    </div>

                    {/* Description */}
                    <p
                      className="mb-2"
                      style={{
                        overflowWrap: "break-word",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      <strong>Description:</strong> {blog.description || "No description"}
                    </p>

                    {/* Status */}
                    <p className="fw-medium mb-0 text-dark">
                      <strong>Status:</strong>{" "}
                      <span
                        className={
                          blog.status === "ACTIVE" ? "badge bg-success" : "badge bg-secondary"
                        }
                      >
                        {blog.status || "INACTIVE"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
